"use client";
import { Heading, TextAttr } from "./attributes";

/** Portable page content, including policies which outlive a commerce module. */
export function RichTextBlock() {
  return <article className="cms-rich-text" style={{ maxWidth: "56rem", marginInline: "auto", padding: "2rem 1.5rem", lineHeight: 1.7 }}>
    <Heading name="heading" /><TextAttr name="body" rich />
  </article>;
}
